export function debounce(f, delay) {
  let t;
  return (...args) => {
    function handler() {
      clearTimeout(t);
      f(...args);
    }
    clearTimeout(t);
    t = setTimeout(handler, delay);
  };
}

function copyProps(target, ...srcs) {
  srcs.forEach(src => {
    global.Object.keys(src).forEach(k => { target[k] = src[k]; });
  });
  return target;
}

export function dup(obj) {
  return copyProps({}, obj);
}



// WEBPACK FOOTER //
// ./src/modules/utils.js


// WEBPACK FOOTER //
// webpack:///src/modules/utils.js